import { render } from "./rectorStudioHome.vue?vue&type=template&id=fdc57c86&scoped=true"
import script from "./rectorStudioHome.vue?vue&type=script&lang=js"
export * from "./rectorStudioHome.vue?vue&type=script&lang=js"

import "./rectorStudioHome.vue?vue&type=style&index=0&id=fdc57c86&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdc57c86"]])

export default __exports__